import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ChatModal from "../components/ChatBox";
import { API_BASE_URL } from "../config";

export default function Messages({ initialChat }) {
  const navigate = useNavigate();
  const [chats, setChats] = useState([]);
  const [activeChat, setActiveChat] = useState(null);
  const authSession = JSON.parse(sessionStorage.getItem("authSession"));
  const token = authSession?.jwt_token;
  const viewer_type = authSession?.role === "astrologer"
    ? "astrologer"
    : "user";
  const viewer_id = authSession?.user_id;

  useEffect(() => {
    if (!authSession) {
      navigate("/login");
    }
  }, [authSession, navigate]);

  // =========================
  // Fetch Conversations
  // =========================
  useEffect(() => {
    fetchChats(); // initial call

    const interval = setInterval(() => {
      fetchChats();
    }, 5000); // 5 seconds

    return () => clearInterval(interval);
  }, []);

  const fetchChats = async () => {
    const res = await axios.get(`${API_BASE_URL}/chat/conversations`, {
      params: {
        viewer_id: viewer_id,
        viewer_type: viewer_type
      },
      headers: { Authorization: `Bearer ${token}` },
    });
    setChats(res.data);
  };

  // =========================
  // Open Chat
  // =========================
  const openChat = async (chat) => {
    setActiveChat(chat);
    if (chat.unseen_count > 0) {
      await axios.post(
        `${API_BASE_URL}/chat/mark-seen`,
        {
          viewer_type,
          user_id: chat.user_id,
          astrologer_id: chat.astrologer_id
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      fetchChats();
    }
  };

  useEffect(() => {
    if (initialChat && chats.length > 0) {
      const chat = chats.find(
        c => c.astrologer_id === initialChat.astrologer_id
      );
      if (chat) {
        openChat(chat);
      }
      // ✅ ELSE → open EMPTY chat UI
      else {
        setActiveChat({
          astrologer_id: initialChat.astrologer_id,
          first_name: initialChat.first_name,
          last_name: initialChat.last_name,
          profile_photo: initialChat.profile_photo,
        });
      }
    }
  }, [initialChat, chats]);

  return (
    <div className="container-fluid p-0" style={{ height: "75vh" }}>
      <div className="row h-100">

        {/* ================= LEFT (COL 3) ================= */}
        <div className="col-3 border-end p-0">
          <div className="list-group rounded-0 h-100 overflow-auto">
            {chats.map((chat) => (
              <button
                key={chat.astrologer_id}
                className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center ${activeChat?.astrologer_id === chat.astrologer_id
                  ? "active"
                  : ""
                  }`}
                onClick={() => openChat(chat)}
              >
                <div>
                  <div className="fw-semibold">{chat.astrologer_name}</div>
                  <small className="text-muted">{chat.last_message}</small>
                </div>

                {chat.unseen_count > 0 && (
                  <span className="badge bg-success rounded-pill">
                    {chat.unseen_count}
                  </span>
                )}
              </button>
            ))}
          </div>
        </div>

        {/* ================= RIGHT (COL 9) ================= */}
        <div className="col-9 p-0 d-flex flex-column">

          {!activeChat && (
            <div className="d-flex flex-column justify-content-center align-items-center h-100 text-muted">
              <i className="bi bi-chat-dots" style={{ fontSize: 80 }}></i>
              <h5 className="mt-3">Select a chat to start messaging</h5>
              <p className="text-center px-5">
                Just like WhatsApp Web — choose a conversation from the left.
              </p>
            </div>
          )}

          {activeChat && (
            <ChatModal
              astrologer={activeChat}
              user_id={viewer_type === "user" ? viewer_id : activeChat.user_id}
              sender={viewer_type}
              token={token}
              onClose={() => {
                setActiveChat(null);
                fetchChats();
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
